var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99967 6.00057H1.99939V3.50033H0.999295V7.50071C0.999295 7.7773 1.22275 8.00076 1.49934 8.00076H5.49972C5.77631 8.00076 5.99977 7.7773 5.99977 7.50071V3.50033H4.99967V6.00057ZM9.91576 2.22209L8.58282 0.221896C8.48907 0.0828203 8.3328 0 8.1656 0H1.83375C1.66655 0 1.51028 0.0828203 1.41808 0.221896L0.0851457 2.22209C-0.13675 2.55493 0.100772 3.00028 0.50081 3.00028H9.5001C9.89857 3.00028 10.1361 2.55493 9.91576 2.22209ZM7.99996 7.75073C7.99996 7.88825 8.11247 8.00076 8.24998 8.00076H8.75003C8.88754 8.00076 9.00005 7.88825 9.00005 7.75073V3.50033H7.99996V7.75073Z",
    fill: "#1E88E5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStore);
export default __webpack_public_path__ + "static/media/icon_store.1519069e04dab178448eba90a4bfe97b.svg";
export { ForwardRef as ReactComponent };